import ServiceGraphQL from 'src/service/gql-service';
import { forgotPassword, resetPassword } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

export const ForgotPassword = (email = '') => {
  const params = {
    query: forgotPassword.QUERY,
    variables: {
      email
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const ResetPassword = (variables) => {
  const params = {
    query: resetPassword.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
